import { AxiosError } from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../../components/Modal';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../../components/Notification';
import HttpStatus from '../../../../../enums/httpStatus';
import { mobileOrderStatusApi } from '../../../../../services/requests';
import * as TP from '../../../../../types/apiResponseTypes';

type Props = {
  closeModal: () => void;
  reqGetAllOrderStatuses: () => void;
  orderStatusSelected: TP.MobileOrderStatus;
};

const DeleteOrderStatus = ({ closeModal, reqGetAllOrderStatuses, orderStatusSelected }: Props) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  const reqDeleteOrderStatus = async () => {
    setIsLoading(true);

    const source = mobileOrderStatusApi.axios.CancelToken.source();

    try {
      const res = await mobileOrderStatusApi.delete(orderStatusSelected.id);

      if (res.status === HttpStatus.OK) {
        setIsLoading(false);
        frontendNotification({
          message: t('successfullyDeleted'),
          type: 'success',
        });

        closeModal();
        reqGetAllOrderStatuses();
      } else {
        throw res;
      }

      setIsLoading(false);
    } catch (err) {
      if (!mobileOrderStatusApi.axios.isCancel(err)) {
        backendErrorNotification(err as AxiosError<any, any>);
      }
      setIsLoading(false);
    }

    return () => {
      source.cancel('Component got unmounted');
    };
  };

  return (
    <Modal
      title={t('deleteOrderStatus')}
      showModal
      closeModal={closeModal}
      action={() => reqDeleteOrderStatus()}
      actionNameBtn={t('delete')}
      isLoading={isLoading}
    >
      <div className="form">
        <div className="form-row">
          <div className="form-row-item">
            <p>
              {`${t('deleteSure')}?`}
              <br />
              <br />
              <b>{t('sigla')}:</b> {orderStatusSelected.sigla || '-'}
              <br />
              <b>{t('description')}:</b> {orderStatusSelected.descricao}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteOrderStatus;
